import { Accept } from 'react-dropzone';
import { GenericTableDataFileDto } from 'inside-fifa/api/generic-tables/dto';

export const ACCEPTED_DATA_FILE_TYPES: Accept = {
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
};

export const DefaultVisibleDataFileTableColumnConfig: Array<keyof GenericTableDataFileDto> = [
    'fileId',
    'name',
    'uploadDateTimestamp',
    'sheets',
];

export const SearchableDataFileTableColumnConfig: Array<keyof GenericTableDataFileDto> = ['name', 'sheets'];
